import { getAvaliacaoStatusId } from '../_shared/avaliacaoStatus';
import { temValorResposta } from '../_shared/avaliacaoRespostaPayload';
import {
  isAvaliacaoAcessoNegado,
  isAvaliacaoEncerradaPorAcessoNegado
} from '../_shared/avaliacaoAccessError';
import {
  wFluxoEntradaAvaliacao,
  wFluxoEntradaStatusEncerrada,
  wFluxoEntradaStatusEntregue,
  wOtpGestorAcessoTamanho
} from './avaliacoesGestorEdit.constants';

export const normalizarOtp = pValor =>
  String(pValor || '')
    .replace(/\D/g, '')
    .slice(0, wOtpGestorAcessoTamanho);

export const formatarCooldownOtp = pRestanteMs => {
  const xTotalSegundos = Math.max(0, Math.ceil(pRestanteMs / 1000));
  const xMinutos = String(Math.floor(xTotalSegundos / 60)).padStart(2, '0');
  const xSegundos = String(xTotalSegundos % 60).padStart(2, '0');

  return `${xMinutos}:${xSegundos}`;
};

export const resolverFluxoEntrada = pStatus => {
  const xStatusId = getAvaliacaoStatusId(pStatus);

  if (xStatusId !== null && xStatusId <= 10) {
    return wFluxoEntradaAvaliacao.gate;
  }

  if (wFluxoEntradaStatusEncerrada.has(xStatusId)) {
    return wFluxoEntradaAvaliacao.encerrada;
  }

  if (wFluxoEntradaStatusEntregue.has(xStatusId)) {
    return wFluxoEntradaAvaliacao.entregue;
  }

  return wFluxoEntradaAvaliacao.questionario;
};

const pvNormalizarRespostaPayload = pResposta => {
  if (pResposta == null) {
    return {};
  }

  if (typeof pResposta === 'string') {
    const xRespostaTexto = pResposta.trim();

    if (!xRespostaTexto) {
      return {};
    }

    try {
      const xParseado = JSON.parse(xRespostaTexto);

      if (xParseado && typeof xParseado === 'object') {
        return xParseado;
      }

      return {
        valor: xParseado
      };
    } catch (_pErro) {
      return {
        valor: pResposta
      };
    }
  }

  if (typeof pResposta === 'object') {
    return pResposta;
  }

  return {
    valor: pResposta
  };
};

const pvObterRespostaDominio = (pQuestaoModelo, pRespostaValor) => {
  const xRespostaDominio = Array.isArray(pQuestaoModelo?.resposta_dominio)
    ? pQuestaoModelo.resposta_dominio
    : [];
  const xValorNormalizado = String(pRespostaValor);

  let xDominioSelecionado = xRespostaDominio.find(
    pDominio => String(pDominio?.valor) === xValorNormalizado
  );

  if (!xDominioSelecionado) {
    xDominioSelecionado = xRespostaDominio.find(
      pDominio => String(pDominio?.id) === xValorNormalizado
    );
  }

  return xDominioSelecionado;
};

export const extrairRespostasGestorPorAvaliacao = (pListByAvaliacaoData = [], pQuestoesModelo = []) => {
  const xQuestoesPorId = (Array.isArray(pQuestoesModelo) ? pQuestoesModelo : []).reduce(
    (pAcc, pQuestao) => {
      const xQuestaoId = Number(pQuestao?.avaliacao_questao_id);

      if (xQuestaoId) {
        pAcc[xQuestaoId] = pQuestao;
      }

      return pAcc;
    },
    {}
  );

  return (Array.isArray(pListByAvaliacaoData) ? pListByAvaliacaoData : []).reduce((pAcc, pItem) => {
    const xQuestaoId = Number(pItem?.avaliacao_questao_id);
    const xQuestaoModelo = xQuestoesPorId[xQuestaoId];

    if (!xQuestaoId || !xQuestaoModelo) {
      return pAcc;
    }

    const xRespostaTipo = pItem?.resposta_tipo || xQuestaoModelo?.resposta_tipo || null;
    const xRespostaPayload = pvNormalizarRespostaPayload(pItem?.resposta);
    const xRespostaValor = xRespostaPayload?.valor;

    if (xRespostaTipo === 'NUM') {
      if (xRespostaValor == null || xRespostaValor === '') {
        return pAcc;
      }

      pAcc[xQuestaoId] = {
        resposta_id: 1,
        resposta_texto: String(xRespostaValor),
        comentario: pItem?.comentario || '',
        nota: pItem?.nota ?? null
      };

      return pAcc;
    }

    const xRespostaId = Number(xRespostaValor);

    if (!temValorResposta(xRespostaValor) || !Number.isFinite(xRespostaId)) {
      return pAcc;
    }

    const xDominioSelecionado = pvObterRespostaDominio(xQuestaoModelo, xRespostaValor);
    const xRespostaSelecionada =
      xRespostaTipo === 'DIC'
        ? xDominioSelecionado?.valor ?? xRespostaId
        : xDominioSelecionado?.id ?? xRespostaId;
    const xRespostaIdFinal = Number(xRespostaSelecionada);

    if (
      !temValorResposta(xRespostaSelecionada) ||
      !Number.isFinite(xRespostaIdFinal) ||
      (xRespostaTipo !== 'DIC' && xRespostaIdFinal <= 0)
    ) {
      return pAcc;
    }

    pAcc[xQuestaoId] = {
      resposta_id: xRespostaIdFinal,
      resposta_texto: xDominioSelecionado?.label || null,
      comentario: pItem?.comentario || '',
      nota: pItem?.nota ?? null
    };

    return pAcc;
  }, {});
};

export const extrairValorResposta = (pQuestao = {}, pResposta = {}) => {
  if (pQuestao?.resposta_tipo === 'NUM') {
    return pResposta?.resposta_texto ?? null;
  }

  if (Array.isArray(pResposta?.resposta_texto)) {
    return pResposta.resposta_texto;
  }

  return pResposta?.resposta_id ?? null;
};

export const formatFileSize = pBytes => {
  if (!pBytes) {
    return '0 B';
  }

  const xUnits = ['B', 'KB', 'MB', 'GB'];
  const xUnitIndex = Math.min(Math.floor(Math.log(pBytes) / Math.log(1024)), xUnits.length - 1);
  const xValue = pBytes / 1024 ** xUnitIndex;

  return `${xValue.toFixed(xUnitIndex === 0 ? 0 : 1)} ${xUnits[xUnitIndex]}`;
};

export const agruparAnexos = (pAnexosAvaliacao = [], pRespostasGestor = {}) => {
  const xGrupos = new Map();
  const xAnexosQuestoes = Object.entries(pRespostasGestor || {}).flatMap(([pQuestionId, pResposta]) => {
    const xAnexosResposta = pResposta?.anexos || [];
    const xAnexosUploading = Boolean(pResposta?.anexos_uploading);

    return xAnexosResposta.map((pFile, pIndex) => ({
      file: pFile,
      questionId: pQuestionId,
      index: pIndex,
      uploading: xAnexosUploading
    }));
  });

  const pvAdicionarAnexo = pAnexo => {
    const xQuestionId = pAnexo?.questionId ? String(pAnexo.questionId) : null;
    const xGrupoKey = xQuestionId ? `questao-${xQuestionId}` : 'avaliacao';
    const xGrupoLabel = xQuestionId ? `Questão ${xQuestionId}` : 'Anexos da avaliação';

    if (!xGrupos.has(xGrupoKey)) {
      xGrupos.set(xGrupoKey, {
        groupKey: xGrupoKey,
        questionId: xQuestionId,
        label: xGrupoLabel,
        anexos: []
      });
    }

    xGrupos.get(xGrupoKey).anexos.push(pAnexo);
  };

  (Array.isArray(pAnexosAvaliacao) ? pAnexosAvaliacao : []).forEach((pAnexo, pIndex) => {
    pvAdicionarAnexo({
      itemKey: `persistido-${pAnexo?.path || pAnexo?.arquivo || 'anexo'}-${pAnexo?.created || ''}-${pIndex}`,
      avaliacao_upload_id: pAnexo?.avaliacao_upload_id || null,
      nome: pAnexo?.arquivo || 'Arquivo',
      questionId: pAnexo?.avaliacao_questao_id || null,
      created: pAnexo?.created || null,
      tamanho: null,
      uploading: false,
      tipo: 'persistido'
    });
  });

  xAnexosQuestoes.forEach(({ file, questionId, index, uploading }) => {
    pvAdicionarAnexo({
      itemKey: `local-${questionId}-${file?.name || 'arquivo'}-${file?.size || 0}-${file?.lastModified || 0}-${index}`,
      nome: file?.name || 'Arquivo',
      questionId: questionId || null,
      created: null,
      tamanho: file?.size || 0,
      uploading,
      tipo: 'local'
    });
  });

  return {
    anexosAgrupados: Array.from(xGrupos.values()),
    anexosQuestoes: xAnexosQuestoes
  };
};

export const isErroAcessoNegado = pErro => {
  return isAvaliacaoAcessoNegado(pErro);
};

export const isErroAvaliacaoEncerradaPorAcessoNegado = pErro => {
  return isAvaliacaoEncerradaPorAcessoNegado(pErro);
};
